import config from '../../../config';

export const inventoryHost = config.config.api_inventory.admin.inventoryHost;
export const hasuraHost = config.config.api_inventory.admin.hasuraHost;


export const openAPICredentials = inventoryHost + "/merchant/stores/"; // + 'STORE_ID'/open-api/create-credentials
